import { Navigate, Outlet, BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Home from './components/Home/Home';
import Layout from './components/layout/Layout';
import Login from './pages/auth/Login';
import Aboutus from './pages/About/Aboutus';
import Signup from './pages/auth/Signup';
import { getLocalStorageData } from './utils/LocalStorageService';
import { useAppDispatch, useAppSelector } from './redux-toolkit/hooks';
import { getAuthData } from './redux-toolkit/slices/authSlice';
import { useGetUserByIdMutation } from './redux-toolkit/services/allUserService';
import { useEffect } from 'react';
import { setFindUserByIdUser } from './redux-toolkit/slices/allUserSlice';
import Logout from './pages/auth/Logout';
import UserMasterReports from './components/MasterReports/UserMasterReports';
import DataSourceMangement from './components/MasterReports/DataSourceMangement';
import Common from './components/MasterReports/Common';
import PDFLibrary from './components/MasterReports/PDFLibrary';
import ProtectedRoute from './components/ProtectedRoute';
import PDFViewerPage from './components/MasterReports/PdfViewer';
import PrivateLibrary from './components/MasterReports/PrivateLibrary';
import PDFUsageLogs from './components/MasterReports/PDFUsageLogs';

function App() {

  const localUserObj = getLocalStorageData("localUser");
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [findUserById, findUserByIdResponse] = useGetUserByIdMutation();

  const authUserData = useAppSelector(getAuthData);

  useEffect(() => {
    if (localUserObj) {
      findUserById({
        id: localUserObj.id,
        token: localUserObj.token
      });
    }
  }, [authUserData]);

  useEffect(() => {
    if (findUserByIdResponse.isSuccess) {
      localStorage.setItem("routeTo", "home")
      dispatch(setFindUserByIdUser(findUserByIdResponse));
    }
  }, [findUserByIdResponse.isSuccess]);

  useEffect(() => {
    if (localUserObj) {
      if (findUserByIdResponse.isSuccess) {
        if (location.pathname === "/login") {
          navigate("/home");

        } else {
          navigate(location.pathname);
        }
      } else if (location.pathname === "/") {
        navigate("/login");
      }
    } else {
      navigate("/login", { replace: true });
    }
  }, [findUserByIdResponse.isSuccess, authUserData]);

  return (
    <div className="App">
      <Routes>

        <Route path="/pdf-viewer/:fileId" element={<PDFViewerPage />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/home" />} />

          {/* Accessible to both Admin and User */}
          <Route path="home" element={<Home />} />
          <Route path="pdf-library" element={<PDFLibrary />} />
          <Route path="library" element={<Outlet />}>
            <Route path=":reportType" element={<PrivateLibrary />} />
            <Route path=":reportType/:categoryName/:language/:languageId" element={<PrivateLibrary />} />
          </Route>
          <Route path="pdf-usage-logs" element={<PDFUsageLogs />} />
          <Route path="data-source" element={<Outlet />}>
            <Route path=":reportType" element={<DataSourceMangement />} />
          </Route>
          {/* Admin-only routes */}
          <Route element={<ProtectedRoute allowedRoles={['Admin']} />}>
            <Route path="usersmaster" element={<Outlet />}>
              <Route path=":reportType" element={<UserMasterReports />} />
            </Route>
            <Route path="common" element={<Outlet />}>
              <Route path=":reportType" element={<Common />} />
            </Route>
          </Route>
        </Route>

        {/* Public routes */}
        <Route path="login" element={<Login />} />
        <Route path="logout" element={<Logout />} />
        <Route path="about" element={<Aboutus />} />
        <Route path="signup" element={<Signup />} />
      </Routes>
    </div>
  );
}

export default App;
